// src/pages/AjouterContrat.jsx
import React, { useState } from 'react';
import Layout from '../../layout/Layout';
import StepHeader from './StepHeader';
import Step1 from './Step1';
import Step2 from './Step2'
import Step3 from './Step3';
import Swal from 'sweetalert2';

const AjouterContrat = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState({
        genre: '',
        nom: '',
        nomEpouse: '',
        prenom: '',
        adresse: '',
        numCI: '',
        profession: '',
        codePostal: '',
        ville: '',
        telephone: '',
        destination: '',
        dateDepart: '',
        dateRetour: '',
        optionFamille: false,
        optionForfait: false,
        remise: 0,
        remisePartenaire: 0,
        remiseExceptionnelle: 0
    });
    const [beneficiaire, setBeneficiaire] = useState([]);

    // Gérer la navigation entre les étapes
    const handleStepChange = (step) => {
        if (step >= 1 && step <= 3) {
            setCurrentStep(step);
        }
    };

    // Gérer la mise à jour des champs de formulaire
    const handleChange = (e) => {
        const { name, value, type, checked, max } = e.target;
    
        let newValue = value;
    
        if (type === 'number') {
            newValue = parseInt(value, 10) || 0; // Parse l'entrée en nombre
            if (max) {
                newValue = Math.min(newValue, Number(max)); // Limite la valeur au max défini
            }
        }
    
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: type === 'checkbox' ? checked : (type === 'number' ? newValue : value),
        }));
    };
    

    // Fonction pour reset les remises
    const handleResetRemise = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            remise: 0,
            remisePartenaire: 0,
            remiseExceptionnelle: 0
        }));
    };

    const handleResetGenre = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            genre: ''
        }));
    }

    const showErrorFormulaire = (message) => {
        Swal.fire({
            title: "Erreur formulaire !",
            text: message,
            icon: "error"
        });
    }

    // Affichage dynamique en fonction de l'étape
    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return <Step1 formData={formData} setFormData={setFormData} handleChange={handleChange} handleStepChange={handleStepChange} handleResetRemise={handleResetRemise} handleResetGenre={handleResetGenre} showErrorFormulaire={showErrorFormulaire} />;

            case 2:
                return <Step2 formData={formData} setFormData={setFormData} handleStepChange={handleStepChange} beneficiaire={beneficiaire} setBeneficiaire={setBeneficiaire} showErrorFormulaire={showErrorFormulaire} dateRetour={formData.dateRetour} />;

            case 3:
                return <Step3 formData={formData} handleStepChange={handleStepChange} beneficiaire={beneficiaire} />;

            default:
                return <div>Contenu de l'étape {currentStep}</div>;
        }
    };

    return (
        <Layout>
            <div className='flex justify-center'>
                <h1 className="text-3xl font-bold text-center text-black">Créer un nouveau contrat</h1>
            </div>
            <div className="p-2">
                <StepHeader currentStep={currentStep} handleStepChange={handleStepChange} />
                {renderStep()}
            </div>
        </Layout>
    );
};

export default AjouterContrat;
